import { render } from "./UploadQueueButton.vue?vue&type=template&id=eafe9a66&scoped=true"
import script from "./UploadQueueButton.vue?vue&type=script&lang=js"
export * from "./UploadQueueButton.vue?vue&type=script&lang=js"

import "./UploadQueueButton.vue?vue&type=style&index=0&id=eafe9a66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eafe9a66"]])

export default __exports__